"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const validators_1 = __importDefault(require("./validators"));
const utils_1 = require("../utils");
const utils_2 = require("./utils");
function useValidation(_a) {
    var { type, validator, eventProcessor, consumerOnChange, value: initialValue, errors: consumerErrors } = _a, configs = __rest(_a, ["type", "validator", "eventProcessor", "consumerOnChange", "value", "errors"]);
    const regExpValidator = createRegExpValidator(configs.regExpStr);
    const thisValidator = validator || validators_1.default[type] || regExpValidator || fallback;
    const validate = (0, utils_2.createValidator)(thisValidator);
    const initialState = {
        value: initialValue,
        isDirty: false,
        isTouched: false,
        lastValidValue: initialValue,
        isValid: validate(initialValue),
        isEmpty: (0, utils_1.isFieldEmpty)(initialValue)
    };
    const [fieldState, setFieldState] = (0, react_1.useState)(initialState);
    const validateOnChangeAndNotifyConsumer = (0, utils_2.createValidateOnChange)(eventProcessor, validate, fieldState, setFieldState, consumerOnChange, consumerErrors, configs);
    const onChangeHandler = validateOnChangeAndNotifyConsumer();
    const onBlurHandler = validateOnChangeAndNotifyConsumer(true);
    const setIsTouched = () => setFieldState((prevState) => (Object.assign(Object.assign({}, prevState), { isTouched: true })));
    const visibleErrors = (0, utils_2.manageFieldErrors)(consumerErrors, fieldState, configs);
    return {
        value: fieldState.value,
        onBlur: onBlurHandler,
        onChange: onChangeHandler,
        displayErrors: setIsTouched,
        errors: visibleErrors
    };
}
exports.default = useValidation;
function fallback() {
    return true;
}
function createRegExpValidator(regexp) {
    if (typeof regexp !== 'string') {
        return null;
    }
    try {
        const re = new RegExp(regexp);
        return (value) => typeof value === 'string' ? re.test(value) : true;
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('Invalid regexp: ' + String(regexp));
        return null;
    }
}
//# sourceMappingURL=use-validation.js.map